import React, { useContext } from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import { convertToInternationalCurrencySystem } from "../../helper";
import { StateContext } from "../../store/context";
import {
  mergeBarChartOptions,
  viChartColors,
} from "../../pages/Compare/chartTheme";

const RevenueQtrOnQtr: React.FC<any> = ({ data }): React.ReactElement => {
  const { series = [], categories = [] } = data || {};
  const { baseCurrency } = useContext(StateContext);

  const chartData: any = {
    options: mergeBarChartOptions({
      colors: [viChartColors[4]],
      chart: {
        id: "RevenueQtrOnQtr",
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            return `${baseCurrency} ${convertToInternationalCurrencySystem(
              String(value)
            )}`;
          },
        },
      },
      xaxis: {
        categories,
      },
      tooltip: {
        shared: true,
        intersect: false,
        hideEmptySeries: false,
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        formatter: (value: string) => {
          return value ? convertToInternationalCurrencySystem(value) : "";
        },
      },
      legend: {
        showForSingleSeries: true,
      },
    }),
    chart: {
      type: "bar",
    },
    series,
  };

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">Revenue: Qtr on Qtr</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={550}
      />
    </div>
  );
};

export default RevenueQtrOnQtr;
